import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import { H4 } from 'ui/bend'
import Text from 'ui/acro/typography/Text'
import { useActiveMembershipContext } from './ActiveMembershipStore'
import NoSubscriptionNoAloAccessView from './NoSubscriptionNoAloAccessView'
import AloSignupAndVerifyLinks from './AloSignupAndVerifyLinks'
import InfoTooltip from './InfoToolTip'
import { ALO_YOGA_HOME_URL } from 'components_v1/SchemaSectionRenderer/common/components/constants'

const Container = styled(Flex)({
  gap: '12px',
  flexDirection: 'column'
})

const TitleSection = styled(Flex)({
  justifyContent: 'space-between',
  alignItems: 'center'
})
const TitleText = styled(H4)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
  textTransform: 'uppercase',
  margin: '0',
  '@media (max-width: 480px)': {
    fontSize: '20px',
    lineHeight: '135%'
  }
})

const Status = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const Description = styled(Text)({
  color: '#3B3B3B',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const CheckPoints = styled('a')({
  color: '#3B3B3B',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px',
  textDecoration: 'underline !important',
  '&:visited': {
    color: '#3B3B3B',
    textDecoration: 'underline !important'
  }
})

const ShowAloAccessStatus = ({ aloLinkedStatus }) => {
  const [showSignup, setShowSignup] = useState(false)
  const descriptionText = aloLinkedStatus ? (
    'ALO Access loyalty program successfully linked with ALO Wellness Club.'
  ) : (
    <>
      <b>Link the ALO Access loyalty program to your account.</b>
      <br />
      Join ALO Access or connect your existing ALO shopping account to unlock
      your benefits, unify your login, and keep your points and status in sync —
      whether you're moving or shopping with us.
    </>
  )
  const params = new URLSearchParams(window.location.search)
  const callbackUrl = params.get('redirect_to')
  // {/* <InfoTooltip
  //   text={
  //     <>
  //       “ALO account” refers to accounts created through shopping{' '}
  //       <a
  //         style={{ textDecoration: 'underline' }}
  //         href={ALO_YOGA_HOME_URL}
  //         target='_blank'
  //         rel='noreferrer'
  //       >
  //         aloyoga.com.
  //       </a>
  //     </>
  //   }
  // /> */}
  // const isUserWithoutSubscriptionAndAloAcces =
  //   membershipTier !== 'PREMIUM' && !aloLinkedStatus
  const aloPointsUrl = window?.REACT_ENV_VARIABLES?.ALO_POINTS_PAGE_URL

  // return isUserWithoutSubscriptionAndAloAcces ? (
  //   <NoSubscriptionNoAloAccessView />
  // ) :
  return (
    <Container>
      <TitleSection>
        <TitleText>ALO Access</TitleText>
        {/* <Status>{aloLinkedStatus ? 'LINKED' : 'NOT LINKED'}</Status> */}
      </TitleSection>
      <Description>{descriptionText}</Description>

      {!aloLinkedStatus && (
        <AloSignupAndVerifyLinks
          showSignup={showSignup}
          setShowSignup={setShowSignup}
          isSettingsPage={true}
          location='manage_membership'
          verifyCallbackUrl={callbackUrl ? callbackUrl : '/'}
        />
      )}
    </Container>
  )
}

export default ShowAloAccessStatus
